import * as React from 'react';
import './Comparisons.css';
import { Bar, BarChart, XAxis, YAxis, LabelList } from 'recharts';

interface Props {
    yourScore: number;
    industryScore: number;
    digitalNativeScore: number;
}

class Comparisons extends React.Component<Props> {
    static defaultProps = {
        yourScore: 0
    };

    render() {
        const { yourScore, industryScore, digitalNativeScore } = this.props;

        const data = [
            {
                yourScoreLabel: 'Your Score',
                yourScore: yourScore,
                industryLabel: 'Your Industry Score',
                industryScore: industryScore,
                digitalNativeLabel: 'Digital Native Score',
                digitalNativeScore: digitalNativeScore
            }
        ];

        const margin = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };

        return (
            <div className="flex-item">
                <div className="comparison-container">
                    <h3>Industry and Digital Native Comparison</h3>
                    <div className="comparison-graph-container">
                        <BarChart
                            width={960}
                            height={160}
                            data={data}
                            margin={margin}
                            layout="vertical"
                            barGap={4}
                        >
                            <XAxis
                                type="number"
                                hide={false}
                                tick={{ strokeWidth: 2 }}
                                ticks={[1, 2, 3, 4, 5]}
                                domain={[ 0, 'dataMax + 0.5' ]}
                                axisLine={{ strokeWidth: 3 }}
                                tickLine={{ strokeWidth: 3 }}
                                padding={{ left: 0, right: 0 }}
                                tickSize={7}

                            />
                            <YAxis
                                type="category"
                                hide={false}
                                tick={false}
                                tickCount={0}
                                width={1}
                                axisLine={{ strokeWidth: 3 }}
                                tickLine={{ strokeWidth: 3 }}
                                padding={{ top: 0, bottom: 0 }}
                            />
                            <Bar dataKey="yourScore" fill="#DFA555">
                                <LabelList dataKey="yourScoreLabel" position="insideLeft"/>
                            </Bar>
                            <Bar dataKey="industryScore" fill="#818181">
                                <LabelList dataKey="industryLabel" position="insideLeft" />
                            </Bar>
                            <Bar dataKey="digitalNativeScore" fill="#00aeef">
                                <LabelList dataKey="digitalNativeLabel" position="insideLeft"  />
                            </Bar>
                        </BarChart>
                    </div>
                </div>
            </div>
        );
    }
}

export default Comparisons;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/Comparisons.tsx